import { html, nothing } from 'lit';
import componentStyles from './cta-card-hero.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';
import {classMap} from "lit-html/directives/class-map";

/**
 * Call to Action image card. Regular and Homepage variant.
 *
 * @element hf-cta-image
 */
export default class CtaCardHero extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      /**
       * XS and LG images object.
       * @type {{xs: string, sm: string, md: string, lg: string, xl: string, xxl: string, altText: string}}
       */
      images: { type: Object },
      /**
       * Main content area title
       */
      title: { type: String },
      /**
       * Main content area text below title
       */
      text: { type: String },
      /**
       * Icon card objects.
       * @type {{title: string, bodyText: string, icon: string, url: string}}
       */
      items: { type: Object },
    };
  }

  render() {
    return html`
      <div
        class="${classMap({
          'cta-card-hero': true,
        })}"
      >
        <div class="cta-card-hero__wrapper">
          <div class="cta-card-hero__content">
            <hf-heading
              level="2"
              levelStyle="heading1"
              class="cta-card-hero__title"
            >
              ${this.title}
            </hf-heading>
            <hf-paragraph class="cta-card-hero__text">
              <hf-wysiwyg markup="${this.text}"></hf-wysiwyg>
            </hf-paragraph>
            <div class="cta-card-hero__card-wrapper">

              ${this.items.map(item => {
                if(item.icon && item.title) {
                  return  html`<hf-link
                    class="cta-card-hero__card-link"
                    styleclass="card-hero"
                    target="${item.target}"
                    href="${item.url}"
                    ignoreExternalUrl
                  >
                    <hf-icon
                      name="${item.icon}"
                      class="cta-card-hero__card-icon"
                      styleclass="card-icon"
                    ></hf-icon>
                    ${item.contextCopy
                      ? html`
                          <p class="cta-card-hero__card-copy-text">
                            ${item.contextCopy}
                          </p>
                        `
                      : nothing}
                    <hf-heading
                      level="3"
                      class="cta-card-hero__card-title"
                    >
                      ${item.title.split(' ').slice(0, -1).join(' ')}
                      <span class="whitespace-nowrap"
                        >${item.title.split(' ').splice(-1)[0]}<hf-icon
                          name="arrow-right"
                          class="cta-card-hero__card-arrow"
                        ></hf-icon
                      ></span>
                    </hf-heading>
                    ${item.bodyText.length
                      ? html`
                          <hf-paragraph class="cta-card-hero__card-text"
                            ><hf-wysiwyg markup="${item.bodyText}"></hf-wysiwyg
                          ></hf-paragraph>
                        `
                      : nothing}
                  </hf-link>`;
                }
              })}
            </div>
          </div>
          <div class="cta-card-hero__image">
            <hf-responsive-image
              imageStyle="cta-card-hero"
            >
              <div slot="image">
                <slot name="image"></slot>
              </div>
            </hf-responsive-image>
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('hf-cta-card-hero', CtaCardHero);
